import { AfterViewInit, Component, Input } from '@angular/core';

@Component({
  selector: 'daily-progress-bar',
  template: `
    <svg
      class="round-progress"
      width="200"
      height="200"
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="100" cy="100" r="85" stroke="#E1E1E1" stroke-width="30" />
      <circle
        [attr.stroke]="color"
        [attr.stroke-width]="strokeWidth"
        [attr.stroke-dasharray]="calculateDashArray()"
        stroke-dashoffset="30"
        [attr.stroke-linecap]="roundedCorners ? 'round' : 'butt'"
        cx="100"
        cy="100"
        r="85"
        transform="rotate(-90 100 100)"
      ></circle>
      <text x="100" y="110" text-anchor="middle" font-size="25" fill="#929292" font-weight="bold">
        {{ progressCount }} / 6
      </text>
      <path
        d="M92 14C91.4477 14 91 14.4477 91 15C91 15.5523 91.4477 16 92 16V14ZM108.707 15.7071C109.098 15.3166 109.098 14.6834 108.707 14.2929L102.343 7.92893C101.953 7.53841 101.319 7.53841 100.929 7.92893C100.538 8.31946 100.538 8.95262 100.929 9.34315L106.586 15L100.929 20.6569C100.538 21.0474 100.538 21.6805 100.929 22.0711C101.319 22.4616 101.953 22.4616 102.343 22.0711L108.707 15.7071ZM92 16H108V14H92V16Z"
        fill="#929292"
      />
    </svg>
  `,
  styles: [
    `
      .round-progress {
        width: 230px;
        height: 230px;
      }
    `,
  ],
})
export class DailyRoundProgressBarComponent {
  @Input() progress: number = 0;
  @Input() progressCount: number = 0;
  @Input() color: string = '#E6A43D';
  @Input() strokeWidth: number = 30;
  @Input() roundedCorners: boolean = true;

  calculateDashArray(): string {
    const circumference = 2 * Math.PI * 85;
    const progressOffset = (circumference * this.progress) / 100;
    return `${progressOffset} ${circumference}`;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/activity-achievement/components/daily-round-progress-bar.component.ts